module.exports = "/_next/static/resources/photo-3-8b26f3323b1da1ae246ac5f9ba7a9d17.webp";